import type { AgentHistoryEntry } from "@/context/agent/types.ts";

const STORAGE_KEY = 'agent_history';
export const AGENT_HISTORY_TTL_MS = 15 * 60 * 1000; // 15 minutes

const isAgentHistoryEntry = (item: AgentHistoryEntry) =>
  typeof item === 'object' &&
  item !== null &&
  typeof item.id === 'string' &&
  typeof item.query === 'string' &&
  typeof item.response === 'string' &&
  typeof item.createdAt === 'string';

const isValidEntryByTtl = (entry: AgentHistoryEntry, nowMs: number): boolean => {
  const createdAtMs = Date.parse(entry.createdAt);
  if (Number.isNaN(createdAtMs)) return false;
  return createdAtMs >= nowMs - AGENT_HISTORY_TTL_MS;
};

export const pruneAgentHistory = (history: AgentHistoryEntry[], nowMs = Date.now()): AgentHistoryEntry[] =>
  history.filter(entry => isValidEntryByTtl(entry, nowMs));

export const getAgentHistory = (): AgentHistoryEntry[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return [];

    const parsed: AgentHistoryEntry[] = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];

    const validated = parsed.filter(isAgentHistoryEntry);
    const pruned = pruneAgentHistory(validated);
    if (pruned.length !== parsed.length) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(pruned));
    }
    return pruned;
  } catch {
    return [];
  }
};

export const setAgentHistory = (history: AgentHistoryEntry[]): void => {
  const pruned = pruneAgentHistory(history);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pruned));
};
